<template>
  <v-app class="price-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74">mdi-chart-line</v-icon>
          </div>
          <div>
            <div class="header-info-title">Info Harga</div>
            <div class="header-info-subtitle">{{ namaPasar }}</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="main-container">
        <div class="content-wrapper">
          <section class="hero-section">
            <div class="hero-decoration hero-decoration-one"></div>
            <div class="hero-decoration hero-decoration-two"></div>

            <div class="hero-content">
              <div class="hero-eyebrow">
                <span class="live-dot"></span>
                INFORMASI PASAR BONDOWOSO
              </div>

              <h1 class="hero-title">
                Belanja lebih bijak,<br />
                <span>mulai dari tahu harganya.</span>
              </h1>

              <p class="hero-description">
                Cari tahu harga bahan pokok di pasar pilihanmu. Informasi harga dalam satu
                tempat, lebih praktis untuk membantu merencanakan belanja sehari-hari.
              </p>

              <div class="hero-pills">
                <div class="hero-pill">
                  <v-icon size="16">mdi-calendar-check-outline</v-icon>
                  Pilih tanggal
                </div>
                <div class="hero-pill">
                  <v-icon size="16">mdi-magnify</v-icon>
                  Cari komoditas
                </div>
                <div class="hero-pill">
                  <v-icon size="16">mdi-currency-usd</v-icon>
                  Cek harga
                </div>
              </div>
            </div>

            <div class="hero-art" aria-hidden="true">
              <div class="hero-art-circle">
                <div class="market-illustration">
                  <div class="market-roof"></div>
                  <div class="market-body">
                    <div class="market-window"></div>
                    <div class="market-door"></div>
                    <div class="market-window"></div>
                  </div>
                  <div class="market-base"></div>
                </div>
                <div class="floating-icon floating-rice">
                  <v-icon color="#018c74" size="25">mdi-barley</v-icon>
                </div>
                <div class="floating-icon floating-cart">
                  <v-icon color="#c78b22" size="25">mdi-basket-outline</v-icon>
                </div>
                <div class="floating-icon floating-chart">
                  <v-icon color="#018c74" size="24">mdi-chart-line</v-icon>
                </div>
              </div>
            </div>

            <div class="hero-bottom">
              <div class="hero-bottom-label">
                <v-icon size="17">mdi-map-marker-outline</v-icon>
                <span>{{ namaPasar }}</span>
              </div>
              <div class="hero-bottom-caption">Informasi harga untuk masyarakat</div>
            </div>
          </section>

          <section class="summary-grid">
            <div class="summary-card summary-card-green">
              <div class="summary-top">
                <div class="summary-icon">
                  <v-icon>mdi-calendar-multiple</v-icon>
                </div>
                <span class="summary-chip">TERSIMPAN</span>
              </div>
              <div class="summary-number">{{ hargaList.length }}</div>
              <div class="summary-title">Periode harga</div>
              <div class="summary-description">Riwayat pencatatan tersedia</div>
              <div class="summary-decoration">
                <v-icon>mdi-calendar-multiple</v-icon>
              </div>
            </div>

            <div class="summary-card summary-card-gold">
              <div class="summary-top">
                <div class="summary-icon">
                  <v-icon>mdi-package-variant-closed</v-icon>
                </div>
                <span class="summary-chip">PERIODE AKTIF</span>
              </div>
              <div class="summary-number">{{ filteredTableData.length }}</div>
              <div class="summary-title">Komoditas ditampilkan</div>
              <div class="summary-description">
                {{ searchKomoditas ? "Sesuai hasil pencarian" : "Daftar bahan pokok" }}
              </div>
              <div class="summary-decoration">
                <v-icon>mdi-package-variant-closed</v-icon>
              </div>
            </div>

            <div class="summary-card summary-card-dark">
              <div class="summary-top">
                <div class="summary-icon">
                  <v-icon>mdi-calendar-month-outline</v-icon>
                </div>
                <span class="summary-chip">PILIHAN</span>
              </div>
              <div class="summary-period">
                {{ activeHarga ? activeHarga.periode : "Belum dipilih" }}
              </div>
              <div class="summary-title">Periode yang dilihat</div>
              <div class="summary-description">
                Gunakan kalender untuk mengganti tanggal
              </div>
              <div class="summary-decoration">
                <v-icon>mdi-calendar-month-outline</v-icon>
              </div>
            </div>
          </section>

          <section class="period-section">
            <div class="section-heading">
              <div class="section-heading-left">
                <div class="section-kicker">
                  <span class="section-kicker-dot"></span>
                  JELAJAHI RIWAYAT
                </div>
                <h2 class="section-title">Mau cek harga tanggal berapa?</h2>
                <p class="section-description">
                  Pilih tanggal pencatatan untuk melihat daftar harga pada periode
                  tersebut.
                </p>
              </div>

              <div class="period-count-badge" v-if="hargaList.length">
                <v-icon size="16">mdi-database-check-outline</v-icon>
                {{ hargaList.length }} periode
              </div>
            </div>

            <div v-if="hargaList.length" class="period-selector-card">
              <div class="period-calendar-icon">
                <v-icon size="26">mdi-calendar-month-outline</v-icon>
              </div>

              <div class="period-selector-main">
                <div class="period-selector-label">PERIODE YANG SEDANG DILIHAT</div>

                <v-menu
                  v-model="datePickerMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290"
                  max-width="340"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      type="button"
                      class="period-date-button"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span class="period-date-value">
                        {{ activeHarga ? activeHarga.periode : "Pilih tanggal" }}
                      </span>
                      <v-icon size="19">mdi-chevron-down</v-icon>
                    </button>
                  </template>

                  <div class="date-picker-panel">
                    <div class="calendar-panel-heading">
                      <v-icon color="#018c74">mdi-calendar-search</v-icon>
                      <div>
                        <strong>Pilih tanggal</strong>
                        <span>Hanya tanggal dengan data yang tersedia</span>
                      </div>
                    </div>

                    <v-date-picker
                      v-model="selectedDate"
                      :picker-date.sync="pickerDate"
                      :allowed-dates="isDateAllowed"
                      color="#018c74"
                      locale="id-ID"
                      no-title
                      full-width
                      class="modern-date-picker"
                      @input="onDateSelected"
                    />

                    <div v-if="allowedDatesCount === 0" class="date-picker-warning">
                      <v-icon x-small color="#a87312">mdi-alert-outline</v-icon>
                      Format tanggal pada data belum dapat dikenali.
                    </div>
                  </div>
                </v-menu>
              </div>

              <div class="period-navigation">
                <v-btn
                  icon
                  small
                  :disabled="!hasPrevPeriode"
                  aria-label="Periode sebelumnya"
                  @click="goToAdjacentPeriode(-1)"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <div class="period-navigation-count">
                  <strong>{{ currentPeriodeIndex + 1 }}</strong>
                  <span>/ {{ hargaList.length }}</span>
                </div>

                <v-btn
                  icon
                  small
                  :disabled="!hasNextPeriode"
                  aria-label="Periode berikutnya"
                  @click="goToAdjacentPeriode(1)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>

            <div v-else class="empty-period">
              <div class="empty-period-icon">
                <v-icon size="31">mdi-calendar-remove-outline</v-icon>
              </div>
              <div>
                <strong>Belum ada riwayat harga</strong>
                <p>Data harga untuk pasar ini belum tersedia.</p>
              </div>
            </div>
          </section>

          <transition name="detail-fade" mode="out-in">
            <section v-if="activeHarga" :key="activeHarga.id" class="detail-panel">
              <div class="detail-heading">
                <div class="detail-heading-copy">
                  <div class="detail-eyebrow">
                    <span class="detail-eyebrow-icon">
                      <v-icon size="15">mdi-chart-box-outline</v-icon>
                    </span>
                    DAFTAR HARGA BAHAN POKOK
                  </div>

                  <h2 class="detail-title">Harga kebutuhanmu.</h2>

                  <p class="detail-subtitle">
                    Temukan komoditas yang ingin kamu cek. Semua harga di bawah mengikuti
                    data pada periode terpilih.
                  </p>
                </div>

                <div class="detail-period-pill">
                  <v-icon size="18">mdi-calendar-check-outline</v-icon>
                  <div>
                    <span>PERIODE DATA</span>
                    <strong>{{ activeHarga.periode }}</strong>
                  </div>
                </div>
              </div>

              <div class="detail-tip">
                <div class="detail-tip-icon">
                  <v-icon size="20">mdi-lightbulb-on-outline</v-icon>
                </div>
                <div>
                  <strong>Tips mencari harga</strong>
                  <p>
                    Ketik nama bahan pokok, misalnya beras, cabai, gula, atau minyak
                    goreng.
                  </p>
                </div>
              </div>

              <div class="search-area">
                <div class="search-label-row">
                  <label class="search-label" for="commodity-search">
                    Cari bahan pokok
                  </label>
                  <span class="search-count">
                    {{ filteredTableData.length }} ditemukan
                  </span>
                </div>

                <div class="search-box">
                  <v-icon class="search-leading-icon">mdi-magnify</v-icon>

                  <input
                    id="commodity-search"
                    v-model="searchKomoditas"
                    type="search"
                    placeholder="Contoh: beras, telur, cabai..."
                    autocomplete="off"
                  />

                  <button
                    v-if="searchKomoditas"
                    type="button"
                    class="search-clear"
                    aria-label="Hapus pencarian"
                    @click="searchKomoditas = ''"
                  >
                    <v-icon size="18">mdi-close-circle</v-icon>
                  </button>
                </div>
              </div>

              <div class="price-table-wrapper">
                <table class="price-table">
                  <thead>
                    <tr>
                      <th class="commodity-column">KOMODITAS</th>
                      <th class="category-column">KATEGORI</th>
                      <th class="unit-column">SATUAN</th>
                      <th class="price-column">HARGA TERCATAT</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(val, idx) in filteredTableData"
                      :key="val.komoditas + '-' + idx"
                      class="price-row"
                    >
                      <td>
                        <div class="commodity-cell">
                          <div class="commodity-icon" :class="commodityColor(idx)">
                            <v-icon size="21">{{ commodityIcon(val.komoditas) }}</v-icon>
                          </div>
                          <div class="commodity-info">
                            <strong class="commodity-name">{{
                              val.komoditas || "Komoditas"
                            }}</strong>
                            <span class="commodity-index">
                              Nomor {{ String(idx + 1).padStart(2, "0") }}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span class="category-text">
                          {{ val.kategori || "Bahan Pokok" }}
                        </span>
                      </td>

                      <td>
                        <span class="unit-badge">{{ val.satuan || "-" }}</span>
                      </td>

                      <td class="price-cell">
                        <div class="price-value">
                          <span class="price-currency">Rp</span>
                          {{ formatPrice(val.harga_sekarang) }}
                        </div>
                      </td>
                    </tr>

                    <tr v-if="filteredTableData.length === 0">
                      <td colspan="4" class="empty-table-cell">
                        <div class="empty-results">
                          <div class="empty-results-icon">
                            <v-icon size="30">mdi-text-search</v-icon>
                          </div>
                          <strong>Belum ketemu, coba kata lain.</strong>
                          <p>Periksa ejaan atau gunakan nama kategori bahan pokok.</p>
                          <v-btn
                            v-if="searchKomoditas"
                            outlined
                            color="#018c74"
                            small
                            rounded
                            @click="searchKomoditas = ''"
                          >
                            Tampilkan semua harga
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mobile-price-list">
                <article
                  v-for="(val, idx) in filteredTableData"
                  :key="'mobile-' + val.komoditas + '-' + idx"
                  class="mobile-price-card"
                >
                  <div class="mobile-card-top">
                    <div class="mobile-commodity">
                      <div class="commodity-icon" :class="commodityColor(idx)">
                        <v-icon size="22">{{ commodityIcon(val.komoditas) }}</v-icon>
                      </div>
                      <div class="mobile-commodity-info">
                        <strong>{{ val.komoditas || "Komoditas" }}</strong>
                        <span>{{ val.kategori || "Bahan Pokok" }}</span>
                      </div>
                    </div>
                    <span class="mobile-unit">{{ val.satuan || "-" }}</span>
                  </div>

                  <div class="mobile-card-bottom">
                    <div class="mobile-price-caption">
                      <v-icon size="15">mdi-tag-outline</v-icon>
                      Harga tercatat
                    </div>
                    <div class="mobile-price-value">
                      <span>Rp</span> {{ formatPrice(val.harga_sekarang) }}
                    </div>
                  </div>
                </article>

                <div v-if="filteredTableData.length === 0" class="mobile-empty">
                  <div class="empty-results-icon">
                    <v-icon size="30">mdi-text-search</v-icon>
                  </div>
                  <strong>Belum ketemu, coba kata lain.</strong>
                  <p>Ubah kata kunci pencarian untuk menemukan bahan pokok.</p>
                  <v-btn
                    v-if="searchKomoditas"
                    text
                    color="#018c74"
                    small
                    @click="searchKomoditas = ''"
                  >
                    Hapus pencarian
                  </v-btn>
                </div>
              </div>

              <div class="result-footer">
                <div class="result-footer-icon">
                  <v-icon size="19">mdi-information-outline</v-icon>
                </div>
                <div class="result-footer-copy">
                  <strong>Catatan informasi harga</strong>
                  <p>
                    Harga yang ditampilkan merupakan data pencatatan pada periode yang
                    dipilih, bukan jaminan harga transaksi di setiap pedagang.
                  </p>
                  <p v-if="activeHarga.deskripsi" class="source-description">
                    {{ activeHarga.deskripsi }}
                  </p>
                </div>
              </div>
            </section>

            <section v-else key="empty" class="empty-detail">
              <div class="empty-detail-art">
                <div class="empty-detail-art-circle">
                  <v-icon size="54">mdi-basket-outline</v-icon>
                </div>
                <span class="empty-spark empty-spark-one"></span>
                <span class="empty-spark empty-spark-two"></span>
              </div>
              <div class="empty-detail-kicker">SIAP MENJELAJAHI HARGA?</div>
              <h2>Belanja dimulai dari informasi.</h2>
              <p>
                Pilih periode pencatatan di atas untuk melihat harga bahan pokok dan
                membantu menyusun kebutuhan belanja.
              </p>
            </section>
          </transition>

          <footer class="page-footer">
            <div class="footer-brand-mark">
              <img src="/images/icon2.png" width="20" />
            </div>
            <div>
              <strong>BONDOWOSO BERKAH</strong>
              <span>Informasi harga bahan pokok untuk masyarakat.</span>
            </div>
          </footer>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getHargaBahanBaru } from "@/api/androidInitApi";

const BULAN_MAP = {
  januari: "01",
  februari: "02",
  maret: "03",
  april: "04",
  mei: "05",
  juni: "06",
  juli: "07",
  agustus: "08",
  september: "09",
  oktober: "10",
  november: "11",
  desember: "12",
};

export default {
  name: "InfoHarga",

  data: () => ({
    hargaList: [],
    activeHarga: null,
    searchKomoditas: "",
    datePickerMenu: false,
    selectedDate: null,
    pickerDate: null,
    loading: false,
  }),

  computed: {
    namaPasar() {
      return this.$route.query.nama || "HARGA BAHAN POKOK";
    },

    filteredTableData() {
      if (!this.activeHarga) return [];

      const rawData = this.parseJsonData(this.activeHarga.data);
      const query = this.searchKomoditas.trim().toLocaleLowerCase("id-ID");

      if (!query) return rawData;

      return rawData.filter((item) => {
        const komoditas = String(item.komoditas || "").toLocaleLowerCase("id-ID");
        const kategori = String(item.kategori || "").toLocaleLowerCase("id-ID");

        return komoditas.includes(query) || kategori.includes(query);
      });
    },

    periodeDateMap() {
      const map = {};

      this.hargaList.forEach((item) => {
        const iso = this.parsePeriodeToISO(item.periode);

        if (iso && !map[iso]) map[iso] = item;
      });

      return map;
    },

    allowedDatesCount() {
      return Object.keys(this.periodeDateMap).length;
    },

    currentPeriodeIndex() {
      if (!this.activeHarga) return -1;

      return this.hargaList.findIndex(
        (item) => String(item.id) === String(this.activeHarga.id)
      );
    },

    hasPrevPeriode() {
      return this.currentPeriodeIndex > 0;
    },

    hasNextPeriode() {
      return (
        this.currentPeriodeIndex >= 0 &&
        this.currentPeriodeIndex < this.hargaList.length - 1
      );
    },
  },

  async mounted() {
    await this.loadHarga();
  },

  methods: {
    async loadHarga() {
      this.loading = true;

      try {
        const targetIdPasar = this.$route.query.id;
        const allHarga = (await getHargaBahanBaru()) || [];

        const list = Array.isArray(allHarga) ? allHarga : [];

        this.hargaList = targetIdPasar
          ? list.filter((item) => String(item.id_pasar) === String(targetIdPasar))
          : list;

        if (this.hargaList.length > 0) {
          this.setActiveHarga(this.hargaList[0], { scroll: false });
        } else {
          this.activeHarga = null;
          this.selectedDate = null;
          this.pickerDate = null;
        }
      } catch (error) {
        console.error("Gagal memuat data harga:", error);
        this.hargaList = [];
        this.activeHarga = null;
      } finally {
        this.loading = false;
      }
    },

    setActiveHarga(item, opts = { scroll: true }) {
      if (!item) return;

      this.searchKomoditas = "";
      this.activeHarga = item;
      this.syncSelectedDate();

      if (opts.scroll) {
        this.$nextTick(() => {
          const element = this.$el.querySelector(".detail-panel");

          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      }
    },

    syncSelectedDate() {
      if (!this.activeHarga) {
        this.selectedDate = null;
        return;
      }

      const iso = this.parsePeriodeToISO(this.activeHarga.periode);
      this.selectedDate = iso;

      if (iso) this.pickerDate = iso.slice(0, 7);
    },

    onDateSelected(value) {
      const item = this.periodeDateMap[value];

      if (item) this.setActiveHarga(item);

      this.datePickerMenu = false;
    },

    isDateAllowed(value) {
      return Object.prototype.hasOwnProperty.call(this.periodeDateMap, value);
    },

    goToAdjacentPeriode(step) {
      if (this.currentPeriodeIndex === -1) return;

      const nextIndex = this.currentPeriodeIndex + step;

      if (nextIndex >= 0 && nextIndex < this.hargaList.length) {
        this.setActiveHarga(this.hargaList[nextIndex]);
      }
    },

    parsePeriodeToISO(periode) {
      if (!periode) return null;

      const value = String(periode).trim();

      let match = value.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);

      if (match) {
        return this.makeISO(match[1], match[2], match[3]);
      }

      match = value.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);

      if (match) {
        return this.makeISO(match[3], match[2], match[1]);
      }

      match = value.toLocaleLowerCase("id-ID").match(/(\d{1,2})\s+([a-z]+)\s+(\d{4})/);

      if (match) {
        const month = BULAN_MAP[match[2]];

        if (month) return this.makeISO(match[3], month, match[1]);
      }

      return null;
    },

    makeISO(year, month, day) {
      const y = Number(year);
      const m = Number(month);
      const d = Number(day);

      if (
        !Number.isInteger(y) ||
        !Number.isInteger(m) ||
        !Number.isInteger(d) ||
        m < 1 ||
        m > 12 ||
        d < 1 ||
        d > 31
      ) {
        return null;
      }

      const date = new Date(Date.UTC(y, m - 1, d));

      if (
        date.getUTCFullYear() !== y ||
        date.getUTCMonth() !== m - 1 ||
        date.getUTCDate() !== d
      ) {
        return null;
      }

      return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    },

    parseJsonData(data) {
      if (!data) return [];

      try {
        if (Array.isArray(data)) return data;

        if (typeof data === "object") return [];

        const parsed = JSON.parse(data);

        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("Gagal membaca data komoditas:", error);
        return [];
      }
    },

    formatPrice(value) {
      if (value === null || value === undefined || value === "") return "0";

      const number = Number(value);

      if (!Number.isFinite(number)) return "0";

      return new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 2,
      }).format(number);
    },

    commodityIcon(name) {
      const value = String(name || "").toLowerCase();

      if (/beras|padi|jagung|gandum/.test(value)) return "mdi-barley";
      if (/cabai|lombok|tomat/.test(value)) return "mdi-chili-mild";
      if (/bawang|sayur|kangkung|bayam|kol|kubis|wortel/.test(value)) {
        return "mdi-leaf";
      }
      if (/telur|ayam|daging|ikan|sapi|kambing/.test(value)) {
        return "mdi-food-drumstick-outline";
      }
      if (/minyak|goreng|santan/.test(value)) return "mdi-bottle-soda-outline";
      if (/gula|garam|tepung/.test(value)) return "mdi-shaker-outline";
      if (/susu|keju|mentega/.test(value)) return "mdi-cup-outline";
      if (/buah|pisang|apel|jeruk/.test(value)) return "mdi-fruit-cherries";
      if (/kedelai|kacang|tempe|tahu/.test(value)) return "mdi-seed-outline";

      return "mdi-basket-outline";
    },

    commodityColor(index) {
      return `commodity-color-${index % 5}`;
    },
  },
};
</script>

<style scoped>
.price-app {
  --teal: #018c74;
  --teal-dark: #006b59;
  --teal-deep: #12483e;
  --teal-soft: #e8f6f1;
  --gold: #e9aa3c;
  --gold-soft: #fff5e3;
  --text: #1c302d;
  --muted: #7d8b87;
  --line: #e9efec;
  --surface: #ffffff;
  --page: #f5f8f6;

  background: var(--page) !important;
}

.main-area {
  background: radial-gradient(circle at 0 10%, rgba(1, 140, 116, 0.045), transparent 25%),
    radial-gradient(circle at 100% 45%, rgba(233, 170, 60, 0.045), transparent 24%),
    var(--page);
}

.main-container {
  padding: 28px 28px 55px !important;
}

.content-wrapper {
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;
  backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;
  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;
  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);
  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1faf8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;
  font-size: 10px;
  color: #929da1;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hero-section {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 300px;
  padding: 37px 42px 65px;
  margin-bottom: 24px;
  overflow: hidden;
  isolation: isolate;
  color: #fff;
  background: linear-gradient(115deg, #075f50 0%, #018c74 60%, #1b9d80 100%);
  border-radius: 28px;
  box-shadow: 0 17px 38px rgba(0, 91, 73, 0.15);
}

.hero-section::before {
  position: absolute;
  content: "";
  width: 380px;
  height: 380px;
  right: 13%;
  top: -235px;
  border: 1px solid rgba(255, 255, 255, 0.11);
  border-radius: 50%;
  z-index: -1;
}

.hero-section::after {
  position: absolute;
  content: "";
  width: 480px;
  height: 480px;
  right: -130px;
  bottom: -350px;
  border: 65px solid rgba(255, 255, 255, 0.055);
  border-radius: 50%;
  z-index: -1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 690px;
}

.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1.6px;
  color: rgba(255, 255, 255, 0.85);
}

.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f7c66d;
  box-shadow: 0 0 0 5px rgba(247, 198, 109, 0.14);
}

.hero-title {
  margin: 18px 0 12px;
  font-size: clamp(31px, 3.7vw, 47px);
  line-height: 1.13;
  letter-spacing: -1.8px;
  font-weight: 900;
  color: white;
}

.hero-title span {
  color: #ffdb91;
}

.hero-description {
  max-width: 570px;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  line-height: 1.85;
}

.hero-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 21px;
}

.hero-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border: 1px solid rgba(255, 255, 255, 0.17);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.09);
  font-size: 10px;
  font-weight: 700;
}

.hero-art {
  flex: 0 0 265px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.hero-art-circle {
  width: 225px;
  height: 225px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.19);
  background: rgba(255, 255, 255, 0.075);
}

.market-illustration {
  width: 120px;
  position: relative;
  filter: drop-shadow(0 14px 15px rgba(0, 48, 37, 0.13));
}

.market-roof {
  height: 48px;
  background: #ffcf76;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}

.market-body {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 76px;
  padding: 10px 8px 0;
  background: #fffaf0;
}

.market-window {
  width: 23px;
  height: 29px;
  border-radius: 4px 4px 0 0;
  background: #9ed9c7;
  border: 3px solid #e0f2e9;
}

.market-door {
  width: 27px;
  height: 46px;
  align-self: flex-end;
  border-radius: 5px 5px 0 0;
  background: #d8a04c;
}

.market-base {
  height: 7px;
  border-radius: 2px;
  background: #e6bd78;
}

.floating-icon {
  width: 49px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 9px 22px rgba(0, 54, 42, 0.13);
  animation: float-gentle 4s ease-in-out infinite;
}

.floating-rice {
  left: -10px;
  top: 25px;
}

.floating-cart {
  right: -5px;
  top: 48px;
  animation-delay: -1.3s;
}

.floating-chart {
  right: 22px;
  bottom: 4px;
  animation-delay: -2.2s;
}

.hero-decoration {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.hero-decoration-one {
  width: 100px;
  height: 100px;
  right: 33%;
  top: -60px;
  background: rgba(255, 255, 255, 0.045);
}

.hero-decoration-two {
  width: 70px;
  height: 70px;
  left: 48%;
  bottom: -50px;
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.hero-bottom {
  position: absolute;
  left: 42px;
  right: 42px;
  bottom: 0;
  min-height: 43px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.hero-bottom-label {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 10px;
  font-weight: 800;
}

.hero-bottom-label span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.hero-bottom-caption {
  color: rgba(255, 255, 255, 0.62);
  font-size: 10px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 17px;
  margin-bottom: 43px;
}

.summary-card {
  min-width: 0;
  min-height: 158px;
  position: relative;
  padding: 20px 21px;
  overflow: hidden;
  border: 1px solid #e8efeb;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 5px 20px rgba(32, 77, 63, 0.035);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 27px rgba(32, 77, 63, 0.075);
}

.summary-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.summary-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
}

.summary-card-green .summary-icon {
  color: #018c74;
  background: #e8f6f1;
}

.summary-card-gold .summary-icon {
  color: #b78023;
  background: #fff4df;
}

.summary-card-dark .summary-icon {
  color: #557e9c;
  background: #edf5fa;
}

.summary-chip {
  padding: 6px 8px;
  border-radius: 7px;
  color: #7c8985;
  background: #f5f8f6;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.6px;
}

.summary-number {
  margin-top: 15px;
  font-size: 29px;
  font-weight: 900;
  letter-spacing: -1px;
  line-height: 1;
  color: #1d3830;
}

.summary-period {
  margin-top: 15px;
  font-size: 19px;
  font-weight: 900;
  letter-spacing: -0.4px;
  color: #1d3830;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.summary-title {
  margin-top: 7px;
  font-size: 12px;
  font-weight: 800;
  color: #334b42;
}

.summary-description {
  margin-top: 5px;
  color: #94a09a;
  font-size: 10px;
}

.summary-decoration {
  position: absolute;
  right: -11px;
  bottom: -20px;
  opacity: 0.045;
  transform: rotate(-15deg);
}

.summary-decoration .v-icon {
  font-size: 94px !important;
  color: #018c74;
}

.period-section {
  margin-bottom: 28px;
}

.section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.section-kicker {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #018c74;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 1.5px;
}

.section-kicker-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e9aa3c;
}

.section-title {
  margin: 9px 0 6px;
  color: var(--text);
  font-size: clamp(21px, 2.5vw, 27px);
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: -0.8px;
}

.section-description {
  margin: 0;
  color: #7f8d86;
  font-size: 12px;
  line-height: 1.7;
}

.period-count-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 12px;
  border-radius: 10px;
  color: #018c74;
  background: #e9f6f1;
  font-size: 10px;
  font-weight: 800;
}

.period-selector-card {
  display: flex;
  align-items: center;
  gap: 17px;
  padding: 20px 22px;
  border: 1px solid #e5eee9;
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 7px 24px rgba(32, 77, 63, 0.035);
}

.period-calendar-icon {
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #018c74;
  background: #e8f6f1;
}

.period-selector-main {
  min-width: 0;
  flex: 1;
}

.period-selector-label {
  margin-bottom: 5px;
  color: #91a099;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.8px;
}

.period-date-button {
  width: 100%;
  max-width: 500px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  border: none;
  outline: none;
  color: #1c302d;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.period-date-button:focus-visible {
  outline: 2px solid #018c74;
  outline-offset: 4px;
  border-radius: 4px;
}

.period-date-value {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.period-date-button .v-icon {
  color: #018c74;
}

.period-navigation {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px;
  border: 1px solid #edf1ee;
  border-radius: 13px;
  background: #f8faf8;
}

.period-navigation .v-btn {
  color: #018c74;
}

.period-navigation .v-btn--disabled {
  color: #c1cbc6 !important;
}

.period-navigation-count {
  min-width: 52px;
  text-align: center;
  white-space: nowrap;
}

.period-navigation-count strong {
  color: #25473b;
  font-size: 12px;
}

.period-navigation-count span {
  color: #99a59e;
  font-size: 11px;
}

.date-picker-panel {
  overflow: hidden;
  border-radius: 17px;
  background: white;
  box-shadow: 0 18px 50px rgba(24, 57, 45, 0.15);
}

.calendar-panel-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 16px 9px;
}

.calendar-panel-heading strong,
.calendar-panel-heading span {
  display: block;
}

.calendar-panel-heading strong {
  color: #25473b;
  font-size: 13px;
}

.calendar-panel-heading span {
  margin-top: 3px;
  color: #899790;
  font-size: 10px;
}

.modern-date-picker {
  box-shadow: none !important;
}

.date-picker-warning {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 14px;
  color: #a87312;
  background: #fffaf0;
  font-size: 10px;
}

.empty-period {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 23px;
  border: 1px dashed #dce8e1;
  border-radius: 17px;
  background: #fff;
}

.empty-period-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #018c74;
  background: #e8f6f1;
  border-radius: 14px;
}

.empty-period strong {
  display: block;
  color: #29473c;
  font-size: 13px;
}

.empty-period p {
  margin: 4px 0 0;
  color: #8a9991;
  font-size: 11px;
}

.detail-panel {
  padding: 30px;
  border: 1px solid #e7efea;
  border-radius: 25px;
  background: #fff;
  box-shadow: 0 12px 38px rgba(32, 77, 63, 0.045);
  scroll-margin-top: 90px;
}

.detail-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 22px;
  margin-bottom: 23px;
}

.detail-heading-copy {
  min-width: 0;
}

.detail-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #018c74;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 1.2px;
}

.detail-eyebrow-icon {
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  color: #018c74;
  background: #e8f6f1;
}

.detail-title {
  margin: 12px 0 7px;
  color: #203b31;
  font-size: clamp(25px, 3vw, 34px);
  font-weight: 900;
  letter-spacing: -1.1px;
  line-height: 1.15;
}

.detail-subtitle {
  max-width: 620px;
  margin: 0;
  color: #839088;
  font-size: 12px;
  line-height: 1.8;
}

.detail-period-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 12px 15px;
  border: 1px solid #e9f0eb;
  border-radius: 14px;
  background: #f8faf8;
}

.detail-period-pill > .v-icon {
  color: #018c74;
}

.detail-period-pill span,
.detail-period-pill strong {
  display: block;
}

.detail-period-pill span {
  color: #91a097;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.8px;
}

.detail-period-pill strong {
  margin-top: 4px;
  color: #29473c;
  font-size: 11px;
}

.detail-tip {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 26px;
  border: 1px solid #f3e7c9;
  border-radius: 14px;
  background: linear-gradient(105deg, #fffaf0, #fffdf8);
}

.detail-tip-icon {
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #b78328;
  background: #fff0ce;
}

.detail-tip strong {
  display: block;
  color: #85611f;
  font-size: 11px;
  font-weight: 900;
}

.detail-tip p {
  margin: 4px 0 0;
  color: #9b855f;
  font-size: 10px;
  line-height: 1.65;
}

.search-area {
  margin-bottom: 16px;
}

.search-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 9px;
}

.search-label {
  color: #304a3e;
  font-size: 11px;
  font-weight: 900;
}

.search-count {
  color: #91a097;
  font-size: 10px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 51px;
  padding: 0 15px;
  border: 1px solid #e6eee9;
  border-radius: 14px;
  background: #f8faf8;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.search-box:focus-within {
  border-color: rgba(1, 140, 116, 0.55);
  background: white;
  box-shadow: 0 0 0 4px rgba(1, 140, 116, 0.065);
}

.search-leading-icon {
  flex-shrink: 0;
  color: #018c74 !important;
}

.search-box input {
  flex: 1;
  width: 100%;
  min-width: 0;
  height: 49px;
  padding: 0;
  border: 0;
  outline: 0;
  color: #29473c;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
}

.search-box input::placeholder {
  color: #a2ada6;
}

.search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #8c9a92;
  cursor: pointer;
}

.price-table-wrapper {
  overflow-x: auto;
  border: 1px solid #e8efea;
  border-radius: 17px;
}

.price-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.price-table thead {
  background: #f7faf8;
}

.price-table th {
  padding: 15px 18px;
  border-bottom: 1px solid #e9efeb;
  color: #819087;
  background: #f7faf8;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.8px;
  text-align: left;
  white-space: nowrap;
}

.price-table th:first-child {
  padding-left: 20px;
}

.commodity-column {
  width: 38%;
}

.category-column {
  width: 25%;
}

.unit-column {
  width: 14%;
  text-align: center !important;
}

.price-column {
  width: 23%;
  text-align: right !important;
}

.price-row {
  transition: background 0.18s ease;
}

.price-row:hover {
  background: #f7fbf9;
}

.price-row td {
  padding: 15px 18px;
  border-bottom: 1px solid #edf2ee;
  vertical-align: middle;
}

.price-row:last-child td {
  border-bottom: none;
}

.commodity-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.commodity-icon {
  width: 43px;
  height: 43px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
}

.commodity-color-0 {
  color: #018c74;
  background: #e8f6f1;
}

.commodity-color-1 {
  color: #b78328;
  background: #fff4df;
}

.commodity-color-2 {
  color: #6786b5;
  background: #edf3fc;
}

.commodity-color-3 {
  color: #b16e91;
  background: #f9edf3;
}

.commodity-color-4 {
  color: #7b8a4c;
  background: #f0f5e5;
}

.commodity-info {
  min-width: 0;
}

.commodity-name {
  display: block;
  color: #294339;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.commodity-index {
  display: block;
  margin-top: 3px;
  color: #a0aaa4;
  font-size: 9px;
}

.category-text {
  display: inline-block;
  padding: 6px 9px;
  border: 1px solid #edf1ee;
  border-radius: 8px;
  color: #7a8980;
  background: #fafbfa;
  font-size: 10px;
  line-height: 1.4;
}

.unit-cell {
  text-align: center;
}

.unit-badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 8px;
  color: #6f7d74;
  background: #f0f4f1;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.price-cell {
  text-align: right;
}

.price-value {
  color: #08765f;
  font-size: 15px;
  font-weight: 900;
  white-space: nowrap;
}

.price-currency {
  margin-right: 2px;
  color: #8ba39a;
  font-size: 10px;
  font-weight: 800;
}

.empty-table-cell {
  padding: 0 !important;
}

.empty-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  text-align: center;
}

.empty-results-icon {
  width: 59px;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  border-radius: 18px;
  color: #018c74;
  background: #e8f6f1;
}

.empty-results strong {
  color: #304a3e;
  font-size: 13px;
  font-weight: 900;
}

.empty-results p {
  max-width: 320px;
  margin: 6px 0 13px;
  color: #8b9991;
  font-size: 11px;
  line-height: 1.7;
}

.mobile-price-list {
  display: none;
}

.mobile-price-card {
  padding: 15px;
  margin-bottom: 11px;
  border: 1px solid #e8efea;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(32, 77, 63, 0.025);
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.mobile-price-card:active {
  transform: scale(0.995);
}

.mobile-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.mobile-commodity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.mobile-commodity-info {
  min-width: 0;
}

.mobile-commodity-info strong {
  display: block;
  color: #294339;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.mobile-commodity-info span {
  display: block;
  margin-top: 3px;
  color: #8b9991;
  font-size: 10px;
  line-height: 1.4;
}

.mobile-unit {
  flex-shrink: 0;
  padding: 6px 9px;
  border: 1px solid #edf1ee;
  border-radius: 8px;
  color: #6f7d74;
  background: #f7f9f7;
  font-size: 10px;
  font-weight: 800;
}

.mobile-card-bottom {
  margin-top: 15px;
  padding: 13px 12px;
  border-radius: 12px;
  background: #f5faf7;
}

.mobile-price-caption {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8b9c92;
  font-size: 10px;
}

.mobile-price-caption .v-icon {
  color: #018c74;
}

.mobile-price-value {
  margin-top: 6px;
  color: #08765f;
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.5px;
  overflow-wrap: anywhere;
}

.mobile-price-value span {
  color: #8ba39a;
  font-size: 12px;
  letter-spacing: 0;
}

.mobile-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 38px 20px;
  text-align: center;
}

.mobile-empty strong {
  color: #304a3e;
  font-size: 12px;
}

.mobile-empty p {
  max-width: 270px;
  margin: 6px 0 10px;
  color: #8b9991;
  font-size: 10px;
  line-height: 1.7;
}

.result-footer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 22px;
  padding: 16px;
  border: 1px solid #e8eee9;
  border-radius: 15px;
  background: #f8faf8;
}

.result-footer-icon {
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #018c74;
  background: #e8f6f1;
}

.result-footer-copy strong {
  display: block;
  color: #385347;
  font-size: 11px;
  font-weight: 900;
}

.result-footer-copy p {
  margin: 5px 0 0;
  color: #829188;
  font-size: 10px;
  line-height: 1.8;
}

.result-footer-copy .source-description {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e6ede8;
  color: #63786c;
}

.empty-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 65px 24px;
  border: 1px solid #e7efea;
  border-radius: 25px;
  background: white;
  box-shadow: 0 10px 35px rgba(32, 77, 63, 0.035);
  text-align: center;
}

.empty-detail-art {
  position: relative;
  margin-bottom: 24px;
}

.empty-detail-art-circle {
  width: 105px;
  height: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  color: #018c74;
  background: linear-gradient(135deg, #e3f5ed, #f4faf6);
  transform: rotate(-5deg);
}

.empty-spark {
  width: 11px;
  height: 11px;
  position: absolute;
  border-radius: 4px;
  background: #edbd61;
}

.empty-spark-one {
  top: 4px;
  right: -12px;
}

.empty-spark-two {
  bottom: 3px;
  left: -10px;
  width: 8px;
  height: 8px;
  background: #a7d8c5;
}

.empty-detail-kicker {
  color: #018c74;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 1.5px;
}

.empty-detail h2 {
  margin: 10px 0 7px;
  color: #294339;
  font-size: clamp(21px, 3vw, 27px);
  font-weight: 900;
  letter-spacing: -0.7px;
}

.empty-detail p {
  max-width: 420px;
  margin: 0;
  color: #85938b;
  font-size: 12px;
  line-height: 1.9;
}

.page-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  margin-top: 34px;
  padding: 15px 0 0;
  border-top: 1px solid #e7eeea;
}

.footer-brand-mark {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #018c74;
  background: #e7f5ee;
}

.page-footer strong,
.page-footer span {
  display: block;
}

.page-footer strong {
  color: #426052;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.8px;
}

.page-footer span {
  margin-top: 4px;
  color: #9aa69f;
  font-size: 10px;
}

.detail-fade-enter-active,
.detail-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.detail-fade-enter,
.detail-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@keyframes float-gentle {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-7px);
  }
}

@media (max-width: 960px) {
  .main-container {
    padding: 24px 18px 45px !important;
  }

  .hero-section {
    padding: 32px 30px 60px;
  }

  .hero-bottom {
    left: 30px;
    right: 30px;
  }

  .hero-art {
    flex-basis: 205px;
  }

  .hero-art-circle {
    width: 185px;
    height: 185px;
    transform: scale(0.92);
  }

  .summary-grid {
    gap: 12px;
  }

  .summary-card {
    padding: 17px;
  }

  .detail-panel {
    padding: 24px;
  }

  .price-table th,
  .price-row td {
    padding-left: 13px;
    padding-right: 13px;
  }
}

@media (max-width: 768px) {
  .main-container {
    padding: 16px 12px 32px !important;
  }

  .hero-section {
    min-height: 0;
    display: block;
    padding: 25px 21px 0;
    margin-bottom: 16px;
    border-radius: 22px;
  }

  .hero-content {
    max-width: 100%;
    padding-bottom: 24px;
  }

  .hero-eyebrow {
    font-size: 8px;
    letter-spacing: 1.1px;
  }

  .hero-title {
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: clamp(27px, 7vw, 36px);
    letter-spacing: -1.1px;
  }

  .hero-description {
    max-width: 100%;
    font-size: 11px;
    line-height: 1.8;
  }

  .hero-pills {
    gap: 6px;
    margin-top: 16px;
  }

  .hero-pill {
    gap: 5px;
    padding: 7px 8px;
    font-size: 9px;
  }

  .hero-art {
    display: none;
  }

  .hero-bottom {
    position: relative;
    left: auto;
    right: auto;
    min-height: 42px;
  }

  .hero-bottom-label {
    flex: 1;
    font-size: 9px;
  }

  .hero-bottom-caption {
    display: none;
  }

  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 30px;
  }

  .summary-card {
    min-height: 143px;
    padding: 14px;
    border-radius: 16px;
  }

  .summary-card:last-child {
    grid-column: 1 / -1;
    min-height: 115px;
  }

  .summary-icon {
    width: 34px;
    height: 34px;
    border-radius: 11px;
  }

  .summary-chip {
    padding: 5px 6px;
    font-size: 7px;
  }

  .summary-number {
    margin-top: 13px;
    font-size: 26px;
  }

  .summary-period {
    margin-top: 12px;
    font-size: 16px;
  }

  .summary-title {
    margin-top: 6px;
    font-size: 10px;
  }

  .summary-description {
    font-size: 9px;
    line-height: 1.5;
  }

  .summary-decoration .v-icon {
    font-size: 72px !important;
  }

  .section-heading {
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 13px;
  }

  .section-kicker {
    font-size: 8px;
    letter-spacing: 1.1px;
  }

  .section-title {
    margin-top: 8px;
    font-size: 20px;
    letter-spacing: -0.5px;
  }

  .section-description {
    font-size: 10px;
    line-height: 1.7;
  }

  .period-count-badge {
    gap: 5px;
    padding: 7px 8px;
    font-size: 8px;
  }

  .period-count-badge .v-icon {
    font-size: 14px !important;
  }

  .period-selector-card {
    display: grid;
    grid-template-columns: 43px minmax(0, 1fr);
    gap: 12px;
    padding: 15px;
    border-radius: 16px;
  }

  .period-calendar-icon {
    width: 43px;
    height: 43px;
    border-radius: 13px;
  }

  .period-calendar-icon .v-icon {
    font-size: 22px !important;
  }

  .period-selector-label {
    font-size: 8px;
    letter-spacing: 0.4px;
  }

  .period-date-value {
    font-size: 13px;
  }

  .period-navigation {
    grid-column: 1 / -1;
    justify-content: space-between;
    padding: 4px 7px;
  }

  .period-navigation-count {
    flex: 1;
  }

  .empty-period {
    padding: 16px;
  }

  .empty-period strong {
    font-size: 11px;
  }

  .empty-period p {
    font-size: 10px;
    line-height: 1.6;
  }

  .detail-panel {
    padding: 17px 13px;
    border-radius: 19px;
  }

  .detail-heading {
    display: block;
    margin-bottom: 17px;
  }

  .detail-eyebrow {
    font-size: 8px;
    letter-spacing: 0.9px;
  }

  .detail-title {
    margin-top: 10px;
    font-size: 25px;
    letter-spacing: -0.7px;
  }

  .detail-subtitle {
    font-size: 10px;
    line-height: 1.8;
  }

  .detail-period-pill {
    margin-top: 14px;
    padding: 10px 12px;
    border-radius: 12px;
  }

  .detail-period-pill strong {
    font-size: 10px;
    overflow-wrap: anywhere;
  }

  .detail-tip {
    gap: 9px;
    padding: 12px;
    margin-bottom: 21px;
    border-radius: 12px;
  }

  .detail-tip-icon {
    width: 31px;
    height: 31px;
  }

  .detail-tip strong {
    font-size: 10px;
  }

  .detail-tip p {
    font-size: 9px;
    line-height: 1.7;
  }

  .search-label {
    font-size: 10px;
  }

  .search-count {
    font-size: 9px;
  }

  .search-box {
    min-height: 46px;
    gap: 9px;
    padding: 0 11px;
    border-radius: 12px;
  }

  .search-box input {
    height: 44px;
    font-size: 11px;
  }

  .price-table-wrapper {
    display: none;
  }

  .mobile-price-list {
    display: block;
  }

  .mobile-price-card {
    padding: 12px;
    margin-bottom: 9px;
    border-radius: 14px;
  }

  .mobile-commodity {
    gap: 9px;
  }

  .mobile-commodity .commodity-icon {
    width: 37px;
    height: 37px;
    border-radius: 11px;
  }

  .mobile-commodity-info strong {
    font-size: 11px;
  }

  .mobile-commodity-info span {
    font-size: 9px;
  }

  .mobile-unit {
    padding: 5px 7px;
    font-size: 9px;
  }

  .mobile-card-bottom {
    margin-top: 12px;
    padding: 10px 11px;
    border-radius: 10px;
  }

  .mobile-price-caption {
    font-size: 9px;
  }

  .mobile-price-value {
    margin-top: 5px;
    font-size: 20px;
  }

  .mobile-price-value span {
    font-size: 11px;
  }

  .result-footer {
    gap: 9px;
    padding: 12px;
    margin-top: 17px;
    border-radius: 12px;
  }

  .result-footer-icon {
    width: 30px;
    height: 30px;
  }

  .result-footer-copy strong {
    font-size: 10px;
  }

  .result-footer-copy p {
    font-size: 9px;
    line-height: 1.8;
  }

  .empty-detail {
    padding: 46px 20px;
    border-radius: 20px;
  }

  .empty-detail-art-circle {
    width: 82px;
    height: 82px;
    border-radius: 25px;
  }

  .empty-detail-art-circle .v-icon {
    font-size: 43px !important;
  }

  .empty-detail h2 {
    font-size: 21px;
  }

  .empty-detail p {
    font-size: 10px;
    line-height: 1.8;
  }

  .page-footer {
    justify-content: flex-start;
    margin-top: 25px;
    padding-top: 15px;
  }

  .page-footer strong {
    font-size: 8px;
  }

  .page-footer span {
    font-size: 9px;
    line-height: 1.6;
  }
}

@media (max-width: 420px) {
  .main-container {
    padding-right: 9px !important;
    padding-left: 9px !important;
  }

  .hero-section {
    padding-right: 16px;
    padding-left: 16px;
  }

  .hero-title {
    font-size: 27px;
  }

  .hero-pill {
    font-size: 8px;
  }

  .summary-card {
    padding: 12px;
  }

  .summary-chip {
    font-size: 6px;
    letter-spacing: 0;
  }

  .summary-number {
    font-size: 24px;
  }

  .summary-period {
    font-size: 14px;
  }

  .section-heading {
    display: block;
  }

  .period-count-badge {
    display: inline-flex;
    margin-top: 10px;
  }

  .detail-panel {
    padding: 14px 10px;
  }

  .detail-title {
    font-size: 23px;
  }

  .mobile-price-value {
    font-size: 18px;
  }

  .mobile-unit {
    max-width: 90px;
    overflow-wrap: anywhere;
    text-align: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>
